import { PreprocessorTypes } from '@cashier/cashier-model';

declare const encryptData: (data: string) => string;

export const PreProcessorConverter = {
  convertValue: (
    value: string,
    preprocessorType: PreprocessorTypes,
  ): string => {
    if (typeof encryptData !== 'function') {
      return value;
    }

    let convertedData = '';

    switch (preprocessorType) {
      case PreprocessorTypes.ENCRYPTOR_V1:
      case PreprocessorTypes.ENCRYPTOR_V2:
        convertedData = encryptData(value.replaceAll(/\s/g, ''));
        break;
    }

    return convertedData || value;
  },
};
